import { useState, useEffect, useRef } from "react";
import ArticleCard from "../../Universal/ArticleCard";
import LoadingSpinner from "../../Universal/LoadingSpinner";
import { CardPreview } from "./Badges";

/* ─── Feed card wrapper (manages hover state for preview) ─── */
export const FeedCard = ({
  id,
  article,
  t,
  onCardClick,
  isActive,
  typeBadge,
  onCardInteract,
}) => {
  const [broken, setBroken] = useState(false);
  if (broken) return null;
  return (
    <div
      className="relative cursor-pointer"
      onClick={() => onCardClick(id, article)}
    >
      <ArticleCard
        investigateDoc={(doc) => onCardClick(id, doc)}
        article={article}
        articleURL={article.url}
        articleLike={article.like}
        articleDislike={article.dislike}
        articleCatalog={article.catalog}
        lid={`${id}||like`}
        dlid={`${id}||dislike`}
        cid={`${id}||catalog`}
        isActive={isActive}
        typeBadge={typeBadge}
        hoverPreview={<CardPreview article={article} t={t} />}
        onInteract={(state) => onCardInteract?.(id, article.document_id, state)}
        onBroken={() => setBroken(true)}
      />
    </div>
  );
};

/* ─── Infinite Scroll Sentinel ─── */
export const ScrollSentinel = ({ onIntersect, hasMore, isLoadingMore, t }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !hasMore) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !isLoadingMore) onIntersect();
      },
      { rootMargin: "400px" },
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [hasMore, isLoadingMore, onIntersect]);
  return (
    <div ref={ref} className="w-full flex justify-center py-8">
      {isLoadingMore && hasMore && <LoadingSpinner />}
      {!hasMore && (
        <p
          className="text-sm font-normal"
          style={{
            // Use t.textMuted when available, fall back to a safe muted value
            color: t?.textMuted ?? "rgba(148,163,184,0.4)",
          }}
        >
          You've reached the end
        </p>
      )}
    </div>
  );
};
